import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_130: FaireProductEntity = {
  token: "legacy_prod_abbott-130",
  type: "product",
  name: "Blue Jay Doormat",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/02e703c4902b27d2914f8907de76429185482229f715759f282d186016e3860b.jpeg",
  priceDollars: 24,
  subcategory: "Outdoor Decor",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
